// src/pages/UserManagement.js
import React, { useState } from 'react';
import './UserManagement.css';

const UserManagement = () => {
  const [users, setUsers] = useState([
    { id: 1, name: "John Doe", email: "john@grab.com", role: "Admin", status: "Active" },
    { id: 2, name: "Jane Smith", email: "jane@grab.com", role: "Analyst", status: "Active" },
    { id: 3, name: "Bob Johnson", email: "bob@grab.com", role: "Viewer", status: "Inactive" }
  ]);
  
  const [isEditing, setIsEditing] = useState(false);
  const [currentUser, setCurrentUser] = useState({ id: '', name: '', email: '', role: 'Viewer', status: 'Active' });

  const handleEdit = (user) => {
    setIsEditing(true);
    setCurrentUser({ ...user });
  };

  const handleDelete = (id) => {
    setUsers(users.filter(user => user.id !== id));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) {
      setUsers(users.map(user => (user.id === currentUser.id ? currentUser : user)));
    } else {
      setUsers([...users, { ...currentUser, id: Date.now() }]);
    }
    setCurrentUser({ id: '', name: '', email: '', role: 'Viewer', status: 'Active' });
    setIsEditing(false);
  };

  return (
    <div className="user-management">
      <h2>User Management</h2>
      
      <div className="user-form">
        <h3>{isEditing ? 'Edit User' : 'Add New User'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                value={currentUser.name}
                onChange={(e) => setCurrentUser({...currentUser, name: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={currentUser.email}
                onChange={(e) => setCurrentUser({...currentUser, email: e.target.value})}
                required
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Role</label>
              <select
                value={currentUser.role}
                onChange={(e) => setCurrentUser({...currentUser, role: e.target.value})}
              >
                <option value="Viewer">Viewer</option>
                <option value="Analyst">Analyst</option>
                <option value="Admin">Admin</option>
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <select
                value={currentUser.status}
                onChange={(e) => setCurrentUser({...currentUser, status: e.target.value})}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
          <button type="submit" className="submit-btn">
            {isEditing ? 'Update User' : 'Add User'}
          </button>
          {isEditing && (
            <button 
              type="button" 
              className="cancel-btn"
              onClick={() => {
                setIsEditing(false);
                setCurrentUser({ id: '', name: '', email: '', role: 'Viewer', status: 'Active' });
              }}
            >
              Cancel
            </button>
          )}
        </form>
      </div>
      
      <table className="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <span className={`status ${user.status.toLowerCase()}`}>
                  {user.status}
                </span>
              </td>
              <td>
                <button 
                  className="action-btn edit-btn"
                  onClick={() => handleEdit(user)}
                >
                  <i className="fas fa-edit"></i> Edit
                </button>
                <button 
                  className="action-btn delete-btn"
                  onClick={() => handleDelete(user.id)}
                >
                  <i className="fas fa-trash"></i> Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserManagement;